"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_admin_1 = require("react-admin");
var Pagination_1 = __importDefault(require("@/Components/common/ReactAdmin/Pagination"));
var RAStyles_1 = require("@/Components/common/ReactAdmin/RAStyles");
var styles_1 = require("@mui/material/styles");
var MeatballMenu_1 = __importDefault(require("@/Components/common/MeatballMenu"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var q_play_core_1 = require("@nordicscreen/q-play-core");
var types_1 = require("@/Types/types");
var inertia_1 = require("@inertiajs/inertia");
var react_i18next_1 = require("react-i18next");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var ApprovedStatusField_1 = __importDefault(require("@/Components/common/ReactAdmin/ApprovedStatusField"));
var GenericSnackbar_1 = __importDefault(require("../GenericSnackbar"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var material_1 = require("@mui/material");
var PrivateAccessModal_1 = __importDefault(require("../PrivateAccessModal"));
var AppTemplateEditorList = function (_a) {
    var versions = _a.versions, fetchVersions = _a.fetchVersions;
    var logger = q_play_core_1.logManager.getLogger();
    var refresh = (0, react_admin_1.useRefresh)();
    var _b = (0, react_1.useState)({}), selectedVersions = _b[0], setSelectedVersions = _b[1];
    var _c = (0, react_1.useState)({}), recordsById = _c[0], setRecordsById = _c[1];
    var _d = (0, react_1.useState)(false), snackbarOpen = _d[0], setSnackbarOpen = _d[1];
    var _e = (0, react_1.useState)(""), snackbarMessage = _e[0], setSnackbarMessage = _e[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var page = (0, useTypedPage_1.default)();
    var _f = (0, react_1.useState)(false), privateAccessModalOpen = _f[0], setPrivateAccessModalOpen = _f[1];
    var _g = (0, react_1.useState)(null), selectedAppTemplateRecord = _g[0], setSelectedAppTemplateRecord = _g[1];
    var deleteTemplate = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.deleteAppTemplate(id)];
                case 1:
                    _a.sent();
                    refresh();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error("Error deleting app template:", error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleVersionChange = function (event, appId) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedVersion, versionParts, version, patchVersion, response, updatedRecord_1, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.stopPropagation();
                    selectedVersion = event.target.value;
                    versionParts = selectedVersion.split(".");
                    version = "".concat(versionParts[0], ".").concat(versionParts[1]);
                    patchVersion = parseInt(versionParts[2], 10);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, AjaxProvider_1.default)("/api").updateAppTemplateVersion(appId, version, patchVersion)];
                case 2:
                    response = _a.sent();
                    updatedRecord_1 = response.data;
                    setSelectedVersions(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[appId] = selectedVersion, _a)));
                    });
                    setRecordsById(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[appId] = updatedRecord_1, _a)));
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    logger.error("Error updating app version", error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        fetchVersions();
    }, []);
    var handleRowClick = function (record) {
        var selectedVersion = selectedVersions[record.id] || record.current_version;
        inertia_1.Inertia.visit("/template-editor/".concat(record.id, "?version=").concat(selectedVersion));
    };
    var handleCopyId = function (e, id) {
        e.stopPropagation();
        navigator.clipboard.writeText(id);
        setSnackbarMessage("App Template Id ".concat(id, " Copied"));
        setSnackbarOpen(true);
    };
    var handleOpenPrivateAccess = function (e, record) {
        e.stopPropagation();
        setSelectedAppTemplateRecord(record);
        setPrivateAccessModalOpen(true);
    };
    return (react_1.default.createElement("div", { style: { marginTop: "150px" } },
        react_1.default.createElement(react_admin_1.ListBase, { perPage: 100, resource: "app-templates", queryOptions: {
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
                refetchOnMount: true,
                refetchInterval: 1000 * 60,
            } },
            react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaDatagridTheme },
                react_1.default.createElement(react_admin_1.Datagrid, { hover: false, bulkActionButtons: false, sx: RAStyles_1.RaAppTemplateDataGridSx, rowClick: function (_, __, record) {
                        handleRowClick(record);
                        return null;
                    }, "data-cy": "appTemplateList" },
                    react_1.default.createElement(react_admin_1.FunctionField, { source: "id", label: t("ID"), render: function (record) { return (react_1.default.createElement("div", { onClick: function (e) { return handleCopyId(e, record.id); }, style: { cursor: "pointer" }, title: "Click to copy ID" }, record.id)); } }),
                    "                        ",
                    react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name"), "data-cy": "appTemplateName" }),
                    react_1.default.createElement(react_admin_1.TextField, { source: "app_id", label: t("App ID") }),
                    react_1.default.createElement(react_admin_1.FunctionField, { label: t("Public"), render: function (record) { return (react_1.default.createElement("span", null, record.public ? "Public" : "Not Public")); } }),
                    react_1.default.createElement(react_admin_1.FunctionField, { label: t("Visibility"), render: function (record) { return (react_1.default.createElement("span", null, record.visible ? "Visible" : "Not Visible")); } }),
                    react_1.default.createElement(react_admin_1.FunctionField, { source: "access", label: t("Access"), render: function (record) { return (react_1.default.createElement("div", { style: { display: "flex", alignItems: "center", gap: "8px" } },
                            react_1.default.createElement("span", null, record.public ? "All" : record.access),
                            !record.public && page.props.is_sysadmin && (react_1.default.createElement(material_1.Button, { onClick: function (e) { return handleOpenPrivateAccess(e, record); }, style: {
                                    padding: "0 5px",
                                    borderRadius: "5px",
                                    backgroundColor: "var(--secondary-color)",
                                    color: "var(--info-color)",
                                    maxWidth: "18px",
                                    minWidth: "18px",
                                    marginBottom: "5px"
                                }, size: "small" }, "+")))); } }),
                    react_1.default.createElement(react_admin_1.FunctionField, { label: t("Version"), render: function (record) {
                            var _a;
                            var selected = selectedVersions[record.id] || record.current_version;
                            return (react_1.default.createElement(q_play_components_1.Select, { value: selected, onChange: function (e) { return handleVersionChange(e, record.id); }, onClick: function (e) { return e.stopPropagation(); }, style: { width: "82px", height: "39px" } }, (_a = versions[record.id]) === null || _a === void 0 ? void 0 : _a.map(function (version) { return (react_1.default.createElement("option", { key: version.full_version, value: version.full_version }, version.full_version)); })));
                        } }),
                    react_1.default.createElement(react_admin_1.FunctionField, { label: t("Approval Status"), render: function (record) {
                            var updatedData = recordsById[record.id]
                                ? __assign(__assign({}, record), recordsById[record.id]) : record;
                            return react_1.default.createElement(ApprovedStatusField_1.default, { record: updatedData });
                        } }),
                    react_1.default.createElement(react_admin_1.FunctionField, { render: function (record) { return (react_1.default.createElement(MeatballMenu_1.default, { onEdit: function () { return inertia_1.Inertia.visit("/template-editor/".concat(record.id)); }, resourceId: record.id, onDelete: function () { return deleteTemplate(record.id); }, resourceType: types_1.ResourceType.APPTEMPLATE })); } }))),
            react_1.default.createElement(Pagination_1.default, { rowsPerPageOptions: [100, 250, 500, 1000] })),
        react_1.default.createElement(GenericSnackbar_1.default, { open: snackbarOpen, onClose: function () { return setSnackbarOpen(false); }, message: snackbarMessage, severity: "success", snackbarStyle: {
                marginLeft: "110px",
            } }),
        react_1.default.createElement("div", { id: "inertiaLinkContainer", style: { display: "none" } }),
        privateAccessModalOpen && (react_1.default.createElement(PrivateAccessModal_1.default, { isShown: privateAccessModalOpen, onClose: function () { return setPrivateAccessModalOpen(false); }, type: "app-template", resourceId: selectedAppTemplateRecord.id, resourceName: selectedAppTemplateRecord.name }))));
};
exports.default = AppTemplateEditorList;
